import React from 'react';
import { Navbar } from '../Home/components/Navbar';
import { Footer } from '../Home/components/Footer';
import './StaticPages.css';

export const Careers = () => {
  const openings = [
    {
      title: "Frontend Developer",
      type: "Full-time",
      location: "Bangalore, India",
      description: "We're looking for a passionate frontend developer to help build beautiful user experiences."
    },
    {
      title: "Backend Developer",
      type: "Full-time",
      location: "Remote",
      description: "Join our backend team to build scalable APIs and services."
    },
    {
      title: "UI/UX Designer",
      type: "Full-time",
      location: "Bangalore, India",
      description: "Help us design intuitive and delightful user interfaces."
    },
    {
      title: "Marketing Manager",
      type: "Full-time",
      location: "Bangalore, India",
      description: "Lead our marketing efforts and help grow our community."
    }
  ];

  return (
    <div className="static-page-wrapper hero-bg-listing-creative">
      <Navbar dark={true} />
      
      <main className="static-page-content">
        <div className="static-page-container">
          <h1 className="static-page-title">Careers at Hobi</h1>
          <p className="static-page-subtitle">Join our mission to help people break out of routine</p>
          
          <section className="static-section">
            <h2>Why Work With Us?</h2>
            <div className="benefits-grid">
              <div className="benefit-card">
                <span className="benefit-icon">🚀</span>
                <h3>Growth Opportunities</h3>
                <p>Learn and grow with a fast-paced startup environment</p>
              </div>
              <div className="benefit-card">
                <span className="benefit-icon">🏠</span>
                <h3>Flexible Work</h3>
                <p>Hybrid and remote options available</p>
              </div>
              <div className="benefit-card">
                <span className="benefit-icon">💪</span>
                <h3>Health Benefits</h3>
                <p>Comprehensive health insurance for you and family</p>
              </div>
              <div className="benefit-card">
                <span className="benefit-icon">🎉</span>
                <h3>Team Events</h3>
                <p>Regular team outings and activities</p>
              </div>
            </div>
          </section>

          <section className="static-section">
            <h2>Open Positions</h2>
            <div className="jobs-list">
              {openings.map((job, index) => (
                <div key={index} className="job-card">
                  <div className="job-info">
                    <h3>{job.title}</h3>
                    <div className="job-meta">
                      <span className="job-type">{job.type}</span>
                      <span className="job-location">{job.location}</span>
                    </div>
                    <p>{job.description}</p>
                  </div>
                  <button className="apply-btn">Apply Now</button>
                </div>
              ))}
            </div>
          </section>

          <section className="static-section text-center">
            <h2>Don't see a role for you?</h2>
            <p>We're always looking for talented people. Send your resume to <strong>careers@hobi.com</strong></p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};
